// Varyantları Yönet penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.variantManagement';

export const inventoryVariantManagementGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Ürün varyantları nasıl oluşturulur?'),
  intro: t(`${G}.intro`, 'Bu pencerede bir ana ürünün renk, beden gibi seçeneklerini (varyantlarını) toplu olarak oluşturur, mevcut varyantların fiyatını ve stoğunu düzenlersiniz. Her varyant ayrı bir stok kartı olarak açılır.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve ana ürün'),
    body: t(`${G}.regions.body`, 'Tip, matris ve varyantlar'),
    footer: t(`${G}.regions.footer`, 'Oluştur / Kapat'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Ana ürünü kontrol edin'),
      text: t(`${G}.s1.text`, '"Ana Ürün" kutusunda varyantları açılacak ürünün adı, stok kodu ve mevcut alt varyant sayısı görünür. Yeni tip (ör. Renk) veya değer (ör. Kırmızı) eklemek için sağ üstteki "Tip ve Değerleri Yönet" düğmesini kullanın.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Tip seçin (en fazla 2)'),
      text: t(`${G}.s2.text`, '"1) Tip Seçimi" bölümünde en fazla 2 tip seçebilirsiniz (ör. Renk x Beden). "Tip 1" matrisin satırlarını, "Tip 2 (Opsiyonel)" sütunlarını oluşturur. Tek tip seçerseniz basit bir liste görünür.'),
      tips: [
        t(`${G}.s2.tip1`, 'Tip kutusunun yanındaki + düğmesi, o tipe yeni değer eklemek için sözlüğü açar. Sözlükte eklediğiniz değerler pencere kapanınca matriste hemen görünür.'),
        t(`${G}.s2.tip2`, 'Tip değiştirildiğinde matristeki seçimler sıfırlanır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Matristen hücreleri işaretleyin'),
      text: t(`${G}.s3.text`, '"2) Matris Seçimi" bölümünde oluşturmak istediğiniz kombinasyonların hücrelerini işaretleyin. "Hepsini Seç" tüm uygun hücreleri seçer, "Seçimi Temizle" seçimi kaldırır.'),
      tips: [
        t(`${G}.s3.tip1`, 'Zaten var olan kombinasyonlar otomatik olarak işaretli ve pasif gelir ("Mevcut"); aynı varyant ikinci kez açılamaz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Resim, miktar ve depo (isteğe bağlı)'),
      text: t(`${G}.s4.text`, '"Seçilen Kombinasyonlar" listesinde her kombinasyona resim ekleyebilir ve başlangıç miktarı yazabilirsiniz. "Tümüne uygula" ile aynı miktarı tüm seçili satırlara verin; "Çıkar" satırı seçimden kaldırır.'),
      tips: [
        t(`${G}.s4.tip1`, 'Miktar girdiyseniz depo seçimi zorunludur. Depo boş bırakılırsa hiçbir varyant için stok kaydı oluşmaz; miktarı boş bırakılan varyantta da stok kaydı oluşmaz.'),
        t(`${G}.s4.tip2`, '"İleri Ayarlar" içindeki "Ürün adına varyant değerlerini ekle" açıkken varyantın adı ana ürün adı + değerler olur. Varyantların stok koduna değerler her zaman eklenir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Varyantları oluşturun'),
      text: t(`${G}.s5.text`, '"Oluştur (n)" düğmesi seçili kombinasyon sayısını gösterir ve en az bir hücre seçilince açılır. Kayıttan sonra kaç varyantın oluşturulduğu, varsa kaç kaydın atlandığı yazılır; liste yenilenir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s6.title`, '6. Mevcut alt varyantları düzenleyin'),
      text: t(`${G}.s6.text`, '"Mevcut Alt Varyantlar" bölümünde her varyantın satış fiyatını ve resmini değiştirip satırdaki "Kaydet" ile kaydedebilirsiniz. "Sil" varyantı onay sorduktan sonra siler.'),
      tips: [
        t(`${G}.s6.tip1`, 'Stok adedi yalnız "Depo (Stok Adedi)" seçilince düzenlenebilir. Yazdığınız sayı, o depodaki miktarın yeni değeri olur (ekleme değil, yerine yazma).'),
        t(`${G}.s6.tip2`, 'Kendi resmi olmayan varyantta ana ürünün resmi gösterilir.'),
      ],
    },
  ],
});
